// @flow

import compose from './compose/composeDataTable'

export {
  SMALL_SIZE,
  MEDIUM_SIZE,
  LARGE_SIZE,
  SIZE_CONFIG,
  AVAILABLE_SIZES_ARR,
  SORT_AS_DATE,
  SORT_AS_MIX,
  SORT_AS_NUMBER,
  SORT_AS_BOOLEAN,
  SORT_AS_GROUP,
  SORT_AS_STRING,
} from './compose/constants'
export default compose
